d<template>
  <div class="absolute fill-height events-page">
    <div class="absolute fill-height pb-3 gui-flex gui-flex-rows">
      <v-toolbar
      color="blue accent-3"
      dark
      extended
      flat
      class="toolbar__fixed"
        >
      </v-toolbar>
      <v-card flat class="no__radius mr-3 ml-3 table-wrap__padding wrap-scrollbar gui-flex-fill-rest gui-flex gui-flex-rows elevation-1">
        <Loader v-if="loading" skin="light"></Loader>
        <div v-else class="gui-flex gui-flex-rows">
          <div class="custom-scrollbar">
            <v-layout row wrap>
              <v-flex xs12>
                <h3>Přehled nezaplacených objednávek a splátek</h3>
              </v-flex>
            </v-layout>
            <v-layout row wrap>
              <v-flex xs12 sm4 lg3>
                <clientsearch label="Vyhledat klienta" v-model="klient" class="mx-2"></clientsearch>
              </v-flex>
            </v-layout>
            <div class="table-border__radius elevation-1">
              <v-data-table
                :headers="headers"
                :items="items"
                :pagination.sync="pagination"
                :total-items="pagination.totalItems"
                :rows-per-page-items="[25, 50, 100, 200]"
                :loading="loadingTable"
              >
                <template slot="items" slot-scope="props">
                  <td>{{ props.item.datum | formatSimpleDate }}</td>
                  <td>
                    <router-link :to="{ path: '/klienti/'+props.item.osoba.id }" target="_blank">{{props.item.osoba.nazev_osoby}}</router-link></td>
                  <td>
                    <span v-if="props.item.typ=='objednavka'">Objednávka</span>
                    <span v-else-if="props.item.typ=='sporeni'">Splátka spoření</span>
                  </td>
                  <td>{{ props.item.predpis | formatMoney }} {{props.item.mena.zkratka}}</td>
                  <td></td>
                  <td>
                    <router-link v-if="props.item.typ=='objednavka' && props.item.objednavka != null" :to="{ path: '/klienti/'+props.item.osoba.id+'/jednorazove-nakupy' }" target="_blank">{{props.item.objednavka.nazev}}</router-link>
                    <router-link v-else-if="props.item.typ=='sporeni' && props.item.sporeni != null" :to="{ path: '/klienti/'+props.item.osoba.id+'/sporici-programy/'+props.item.sporeni.id }" target="_blank">{{props.item.sporeni.nazev}}</router-link>
                  </td>
                </template>
              </v-data-table>
            </div>
          </div>
        </div>
      </v-card>
    </div>
  </div>
</template>

<script>
import Base from '@/pages/Base'
export default {
  extends: Base,
  data () {
    return {
      loading: false,
      headers: [
        { text: 'Plánovaný datum platby', value: 'datum' },
        { text: 'Klient', value: 'osoba' },
        { text: 'Typ', value: 'typ' },
        { text: 'Částka', value: 'predpis' },
        { text: 'Splatnost', value: 'splatnost', sortable: false },
        { text: 'Objednávka/spoření', value: 'splatnost', sortable: false }
      ],
      items: [],
      loadingTable: true,
      search: "",
      timeout: null,
      counter: 0,
      pagination: {
        descending: true,
        page: 1,
        rowsPerPage: 50,
        sortBy: "datum",
        totalItems: 0
      },
      klient: null
    }
  },
  mounted: function() {
    window.MenuListener.show();
    this.load();
  },
  watch: {
    klient () {
      this.load();
    },
    pagination: {
      handler () {
        this.load();
      },
      deep: true
    }
  },
  methods: {
    queryList: function() {
      if (this.timeout != null)
        clearTimeout(this.timeout);
      this.timeout = setTimeout(function() {
        this.pagination.page = 1;
        this.load();
      }.bind(this), 200)
    },
    load: function() {
      this.counter++;
      this.loadingTable = true;
      window.API.post("prehledy/nezaplacene/search", {
        pagination: this.pagination,
        s: this.search,
        echo: this.counter,
        osoba: this.klient
      }).then(function(body) {
        if (this.counter != body.echo)
          return;
        this.items.replace(body.data);
        this.pagination.sortBy = body.sort.sortBy;
        this.pagination.descending = body.sort.descending;
        this.pagination.page = body.sort.page;
        this.pagination.rowsPerPage = body.sort.rowsPerPage;
        this.pagination.totalItems = body.sort.totalItems;
        this.loading = false;
        this.loadingTable = false;
      }.bind(this)).catch(function(err) {
        console.log(err);
      }.bind(this));
    }
  },
}
</script>



// WEBPACK FOOTER //
// src/pages/Platby/NezaplaceneObjednavky.vue